import {useEffect, useState} from 'react';
import './OfferDetailsDisplay.css'
import LoginBar from '../Header/LoginBar/LoginBar';
import { useHistory } from 'react-router-dom';
import { TfiArrowCircleLeft } from "react-icons/tfi";
import { useAtom } from 'jotai';
import ImageCollage from '../ImageColage/ImageCollage';
import { getAuth } from "firebase/auth";
import { useDetailedOffer, useModalVersion, useShowPopUpModal, useShowDetailedCard, useAllCompanies, useLoggedUser, useModalInfo, useCompaniesLogosUrls, useDetailed } from '../../data/GlobalStates';



const OffersDetailsDisplay = ({get, db, child, dbRef, set, OfferDetailsRef}) => {

    const history = useHistory();
    const authedUser = getAuth();
    const date = new Date();
    let year = date.getFullYear();
    let month = date.getMonth() + 1;
    let day = date.getDay();  

    //stany lokalne:
    const [ ShowCompanyDetails, setShowCompanyDetails ] = useState(false);
    const [ CompanyDetails, setCompanyDetails ] = useState('');

    //stany globalne:
    const [ DetailedOffer, setDetailedOffer ] = useAtom(useDetailedOffer);
    const [ ShowDetailedCard, setShowDetailedCard ] = useAtom(useShowDetailedCard);
    const [ AllCompanies, setAllCompanies ] = useAtom(useAllCompanies);
    const [ detailed, setDetailed ] = useAtom(useDetailed);


    useEffect(() => {
      if (AllCompanies.length) {
         setCompanyDetails(AllCompanies.filter(company => company.name === detailed.companyName)[0])
      }
    },[AllCompanies])

    useEffect(() => {

      const scrollCompanyDescription = () => {
         const companyDescriptionContainer = document.getElementById('CompanyInfoDescriptionContainer')
         const title = document.getElementById('FirstDetails')
         
           if (ShowCompanyDetails) {
            companyDescriptionContainer.scrollIntoView({ behavior: 'smooth' })
         } else if (!ShowCompanyDetails) {
            title.scrollIntoView({ behavior: 'smooth' })
         }
       };
      
       scrollCompanyDescription()
       
    },[ShowCompanyDetails])


const closeModal = () => {  
    if (history.location.pathname === '/DodajNews') {
      return
    } else if (history.location.from === 'userPanel') {
        history.push('/userPanel')
        setDetailedOffer('')
        setShowCompanyDetails(false)
    } else {
        history.push('/')
        setDetailedOffer('')
        setShowCompanyDetails(false)
    }
 };
 



        return(
          <>
          <LoginBar/>

 <div id='OfferDetailsDiv'>
               
               <div id='FirstDetails'>
                  <div className='NavigationContainer' onClick={() => closeModal()}>
                      <TfiArrowCircleLeft className='BackToMainBtn'/>
                      <p className='BackInfoText'>Powrót</p>
                  </div>

                    <div className='DetailContainer'>
                        <h3 className='DetailContainerTitleText'>{detailed.title}</h3>
                     </div>
                     

               </div>
                 {
                    detailed.ImagesUrls ? <ImageCollage images={detailed.ImagesUrls} /> : null
                 }
                  <div id='DetailsDiv1'>
                
    
    {
      detailed.YouTubeURL ? 
      <>
           <iframe
            key={detailed.id}
            className="detailed-video"
            src={detailed.YouTubeURL}
            title="YouTube video"
            allowFullScreen
          />
      </>
      : ''
    }
                     </div>


               <div id='DescriptionContainer'>
                 <h3 id='Description'>
                  <pre id='FormattedText'>{detailed.description}</pre></h3>
               </div>
      
 
               <div id='CompanyInfoMiniLogoContainer' onClick={() => closeModal()}>
                 <p className='OfferDetailsDisplayMiniLogo'>Polska Akademia Tyczki</p>
               </div>
           </div>
          </>
           
       )
}

export default OffersDetailsDisplay;
